import uid from 'uid';

export const uniquifyName = (userName) => `${userName}-${uid(4)}`;

export const getOriginalName = (uniqueUserName) => uniqueUserName.split('-')[0];
